<header>
    <div class="layout-header-full fixed-top">
        <app-header-full></app-header-full>
    </div>
</header>

<div id="secureLayoutPageId" class="container-fluid layout-container">
    <!-- Main Body/Content -->
    <div class="row g-0">
        <div class="col">
            <div class="layout-content-wrapper">
                <ng-container *ngIf="isMaintenanceMode; else regularContent">
                    <div class="white-panel maintenance-mode-banner">
                        <div class="mb-1">
                            We're currently updating our systems to serve you
                            better.
                        </div>
                        {{
                            maintenanceModeDisplayMssg ||
                                'The site will be back online at 5:00 AM PST. Thank you for your patience.'
                        }}
                    </div>
                </ng-container>

                <ng-template #regularContent>
                    <ng-container
                        *ngIf="
                            userPermissionsReceived;
                            else rbacUserPermissionsNotReceived
                        "
                    >
                        <!-- Regular flow -->
                        <ng-content></ng-content>
                    </ng-container>

                    <!-- Template when no RBAC User Permissions received from API -->
                    <ng-template #rbacUserPermissionsNotReceived>
                        <div class="header-title mb-3">Shopper Support</div>
                        <div class="white-panel no-access-dialog">
                            <qm-kendo-loading
                                [loading]="isLoading"
                                [customStyles]="'top: 30%;'"
                            ></qm-kendo-loading>
                            <div *ngIf="!isLoading">
                                <div class="mb-1"> User not authorised! </div>
                                Please try again later or contact your admin.
                            </div>
                        </div>
                    </ng-template>
                </ng-template>
            </div>
        </div>
    </div>
</div>

<app-footer [isLight]="false"> </app-footer>
